<template>
  <div id="user" :key="componentKey">
      <form-password
      :params="params"      
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert">
      </form-password>
      <vx-card class="mb-base">
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <h3>{{translate('General')}}</h3>
            <vs-button :style="getSide" v-if="mode=='view'" type="flat" color="primary" icon-pack="feather" icon="icon-edit" @click="mode='edit'">{{translate('Edit')}}</vs-button>
            <vs-button :style="getSide" v-if="mode=='edit'" type="flat" color="success" icon-pack="feather" icon="icon-save" @click="saveAll">{{translate('SaveAll')}}</vs-button>
          </div>
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4" v-if="mode=='edit'">
              <file-upload
                extensions="gif,jpg,jpeg,png,webp"
                accept="image/png,image/gif,image/jpeg,image/webp"
                :multiple="false"
                :size="1024 * 1024 * 10"
                v-model="params.files"
                ref="upload">
                <img v-if="params.files.length>0 && params.files[0].thumb" :src="params.files[0].thumb" width="100" height="auto" />
                <img v-else :src="mainImage" class="rounded w-full" />
              </file-upload>
            </div>
            <div class="img-container mb-4" v-else>
              <img :src="mainImage" class="rounded w-full"  style="width:125px !important"/>
            </div>
          </div>
          <!-- Information - Col 1 -->
          <table>
            <tr>
              <td class="font-semibold">{{translate('UserName')}}: </td>
              <td v-if="mode==='view'">{{params.username}}</td>
              <td v-else><vs-input class="inputx inline-block" size="normal" v-model="params.username"/></td>
            </tr>
            <tr>
              <td class="font-semibold">{{translate('Email')}}: </td>
              <td v-if="mode==='view'">{{params.email}}</td>
              <td v-else><vs-input class="inputx inline-block" size="normal" v-model="params.email"/></td>
            </tr>
            <tr>
              <td class="font-semibold">{{translate('Agent')}}: </td>
              <td v-if="mode==='view'">{{params.agent}}</td>
              <td v-else><vs-input class="inputx inline-block" size="normal" v-model="params.agent"/></td>
            </tr>            
          </table>
          <div class="vx-col">
            <table>
              <tr>
                <td class="font-semibold">{{translate('RiskGroup')}}: </td>
                <td v-if="mode==='view'">{{params.risk_group}}</td>
                <td v-else><vs-input class="inputx inline-block" size="normal" v-model="params.risk_group"/></td>
              </tr>              
                <tr>
                    <td class="font-semibold">{{translate('systemLanguage')}}: </td>
                    <td v-if="mode==='view'">{{translate(params.language)}}</td>
                    <td v-else>
                    <vs-select
                    class="inputx w-full"
                    v-model="params.language"
                    autocompletender
                    :placeholder="translate('SelectLanguage')">
                    <vs-select-item :key="index" :value="item.value" :text="translate(item.text)" v-for="(item,index) in languageData"/>
                    </vs-select></td>
                </tr>
                <tr>
                    <td class="font-semibold">{{translate('systemTheme')}}</td>
                    <td v-if="mode==='view'">{{params.theme}}</td>
                    <div v-else>
                        <vs-radio v-model="themeMode" vs-value="light" class="mr-4" vs-name="theme-mode-light">Light</vs-radio>
                        <vs-radio v-model="themeMode" vs-value="dark" class="mr-4" vs-name="theme-mode-dark">Dark</vs-radio>
                        <vs-radio v-model="themeMode" vs-value="semi-dark" vs-name="theme-mode-semi-dark">Semi Dark</vs-radio>
                    </div>
                </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
        </div>
        
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="translate('NavMenu')" class="mb-base">
            <vs-list>                
                <vs-list-item :title="item" v-for="(item,index) in navList" :key="index">
                    <vs-checkbox color="success" :checked="navParams[item]===true" @click="addOrRemoveMenu(item)"/>
                </vs-list-item>
            </vs-list>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="translate('AllowedFields')" class="mb-base">
              <vs-select
                class="inputx w-full"
                v-model="params.tableData"
                @change="getAllowedFields"
                autocompletender
                :placeholder="translate('SelectTable')">
                <vs-select-item :key="index" :value="item.view" :text="translate(item.name)" v-for="(item,index) in tablesData"/>
            </vs-select>
            <vs-list>                
                <vs-list-item :title="item" v-for="(item,index) in allowedFields" :key="index">
                    <vs-checkbox color="success" :checked="fieldsParams[item]===true" @click="addOrRemoveSection(item)"/>
                </vs-list-item>
            </vs-list>
          </vx-card>
        </div>
         <div class="vx-col lg:w-1/2 w-full" v-if="$route.params.userName==='admin'">
          <vx-card :title="translate('AllowedFields')" class="mb-base">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-button @click="updateStage()" color="primary" type="filled">Update stage</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "@/axios.js"
import FormPassword from '../../components/forms/Password';
import FileUpload from 'vue-upload-component'
export default {
  data() {
    return {
        componentKey:0,
        popUps:{popupAddActive:false},
        mode: 'view',
        mainImage: require("@/assets/images/profile/profile.png"),
        languageData:[
            {text:'English',value:1},
            {text:'Russian',value:2}
        ],
        RiskGroups:[],
        navList: [],
        tablesData: [
            {name:'Transactions',view:'tran_section'},
            {name:'Clients',view:'client_section'},
            {name:'Documents',view:'doc_section'},
            {name:'Brokers',view:'broker'},
            {name:'Banking',view:'deposit_section'}],
        allowedFields: [],
        fieldsParams:{},
        params: {
            files:[]
        },
        socialData: {
            facebook:'',
            twitter:'',
            instagram: ''
        },
    }
  },
  components:{
    FileUpload,
    FormPassword
  },
  computed:{
    themeMode: {
      get()    { return this.$store.state.theme },
      set(val) { this.$store.dispatch('updateTheme', val) }
    },
    getSide: function(){
      return this.$vs.rtl ? 'position: absolute;left: 0px' : 'position: absolute;right: 0px';
    }
  },
  methods: {
    updateStage: function(){
      let that = this;
      axios.post("/api/update-stage")
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.status==='waiting'){
          that.openAlert('success','Success','Please check stage in 2 min');
        } else{
          that.openAlert('danger','Failed');
        }
        })
      .catch(() => {that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    closePopups: function(){
      this.componentKey++;
      this.popUps.popupAddActive = false;
      this.formParams = {formType:'add'};
      this.$forceUpdate();
    },
    addOrRemoveMenu: function(item){
      if(this.navParams[item]===undefined){
        this.$set(this.navParams,item,true);
      } else{
        this.$set(this.navParams,item,!this.navParams[item]);
      }
      this.updateMenu(item,this.navParams[item]);
    },
    addOrRemoveSection: function(item){
      if(this.fieldsParams[item]===undefined){
        this.$set(this.fieldsParams,item,true);
      } else{
        this.$set(this.fieldsParams,item,!this.fieldsParams[item]);
      }
      this.updateGroup(item,this.fieldsParams[item]);
    },
    translate: function(key){
      return this.$t(key);
    },
    saveAll: function(){
      this.mode='view';
      /*if(this.params.files.length>0)
        this.uploadFile();
      this.sendLinksData();*/
    },
    updateMenu: function(field,isEdit){
      let that = this;
      this.$vs.loading();
      const obj = {
        action: isEdit ? 'edit-menu' : 'remove-menu',
        field: field,
        group: this.params.risk_group
      }
      axios.post("/api/users",obj)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success==='done!'){
          that.openAlert('success','Success');
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        })
      .catch(() => {that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    updateGroup: function(field,isEdit){
      let that = this;
      this.$vs.loading();
      const obj = {
        action: isEdit ? 'edit-group' : 'remove-group',
        field: field,
        group: this.params.risk_group,
        view: this.params.tableData
      }
      axios.post("/api/users",obj)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success==='done!'){
          that.openAlert('success','Success');
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    uploadFile () {
        const formData =new FormData();
        formData.append('type', 'file-upload');
        formData.append('document',this.params.files[0].file);
        formData.append('title','Contact profile image');
        formData.append('comment','Only on image can be set as main');
        formData.append('folder','contacts/'+this.$route.params.contactId);
        formData.append('contact_id',this.$route.params.contactId);
        formData.append('mainImage',true);
        let that = this;
        this.$vs.loading();
        axios.post("https://api.weaver-app.com/v1/documents",formData)
        .then((data) => {
            that.$vs.loading.close();
            that.mode = 'view';
            that.$forceUpdate(); 
            if(data.data.success){
              //that.openAlert('success','Image uploaded');
              
            }
        })
    },
    getAllowedFields: function(){
      let that = this;
      let obj = {
          id:this.$route.params.userName,
          action: 'list-fields',
          view: this.params.tableData
      }      
      this.allowedFields.splice(0);
      this.fieldsParams = {};
       axios.post('/api/users',obj)
        .then((response) => {
          for(let i in response.data.allFields){
              that.allowedFields.push(response.data.allFields[i]);
          }
          for(let i in response.data.userFields){
              that.$set(that.fieldsParams,response.data.userFields[i],true)              
          }
          that.$forceUpdate();
        })
        .catch(() => { })
    },
    sendLinksData: function(){
      let that = this;
      this.$vs.loading();
      let params = {...this.socialData};
      axios.post("https://api.weaver-app.com/v1/links/"+this.$route.params.contactId+'?type=byContact',params)
      .then(() => {
        that.$vs.loading.close();
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    pretifyName: function(name){
      return name.replace('property_','');
    },
    getRiskGroups: function(){
      let obj = {
          action: 'get-groups',
      }
      axios.post('/api/users',obj)
        .then(() => {
        })
      .catch(() => {  })
        
    },
    setData: function(){
      let that = this;
      let obj = {
          id:this.$route.params.userName,
          action: 'get-row',
          view: this.params.tableData
      }      
      this.navParams = {};
      this.navList.splice(0);
       axios.post('/api/users',obj)
        .then((response) => {
          for(let i in response.data.details){
              that.$set(that.params,i,response.data.details[i]);
          }
          for(let i in response.data.allSections){
              that.navList.push(response.data.allSections[i].name);
          }
          for(let i in response.data.userSections){
              that.$set(that.navParams,response.data.userSections[i].name,true)              
          }
          that.$forceUpdate();
        })
        .catch(() => {})
    },
  },
  created() {
    this.getRiskGroups();
    this.setData();
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>